export const ROOT_URL = 'https://api.carecity.io';

class HttpMessage {

  static async sendMessage(message) {
    let returnValue = null;
    try {
      const response = await fetch(message.route, {
        method: message.method,
        body: message.body,
        header: message.header
      });

      returnValue = await response.json();
      if (!returnValue || returnValue.status === 'error') {
        console.log(returnValue);
      }
    }
    catch (error) {
      console.warn(error);
      returnValue = { status: 'error', message: 'Error encountered.' };
    }

    return returnValue;
  }
}

export default HttpMessage;
